export default __webpack_public_path__ + "static/media/course-symb.61f8f707.svg";